import React from 'react'
import Color from '../../../components/Field.Color'

import Card from './Card'
import Group from './Group'
import Label from './Group.Label'
import Item from './Group.Item'

function Component(
    {
        fieldLayout,
        disabled,

        select,
        onChange,
    }
)
{
    return (
        <Card title="รีวิว" >
            <Group>
                <Item>
                    <Label> </Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="พื้นหลัง"
                                name="review.bgColor"
                                alpha={false}
                                value={select('review.bgColor')}
                                onChange={onChange}
                            />
                            
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="หัวข้อ"
                                name="review.title.color"
                                alpha={false}
                                value={select('review.title.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
                <Item>
                    <Label>รายการ</Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="เส้นขอบ"
                                name="review.item.borderColor"
                                alpha={false}
                                value={select('review.item.borderColor')}
                                onChange={onChange}
                            />

                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="ข้อความ"
                                name="review.item.color"
                                alpha={false}
                                value={select('review.item.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
            </Group>
        </Card>
    )
}

export default Component